import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {
    Button,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row
} from 'reactstrap';

import {badPassword, error, REQUIRED, selectOption, success, updatePassword} from "../../../components/i18n/i18n";
import {ButtonCancel, ButtonSubmitPassword} from "../../../components/buttons/buttonsActions";
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import {userService} from "../../../jwt/_services";
import {showToastCustom} from "../../../components/toast/customToast";
import {userProvider} from "../../../providers/userProvider";
import Select from "react-select";
import {utilHelper} from "../../../jwt/_helpers";


export const UserPasswordModal = forwardRef((props, ref) => {

    const [modal, setModal] = useState(false);
    const [isPasswordShown, setIsPasswordShown] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [user, setUser] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const validationSchema = Yup.object().shape({
        old_password: Yup.string().required(REQUIRED),
        password: Yup.string().required(REQUIRED),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Las contraseñas deben coincidir')
    });

    const validationSchemaAdmin = Yup.object().shape({
        password: Yup.string().required(REQUIRED),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Las contraseñas deben coincidir')
    });

    //Para determinar si el usuario es un adminitrador o no
    /*useEffect(() => {
        let currentUser = ( localStorage.getItem('currentUser') != '' ? JSON.parse(localStorage.getItem('currentUser')) : null);
        let admin = userService.hasRoleAdmin(currentUser);
        setIsAdmin(admin);
        if(admin){
            userProvider.listAllUserExcludeCurrentLogin()
                .then(result => {
                    if (result)
                        setUserOptions(result);
                })
                .catch(_ => {
                });
        }
    }, []);*/

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: isAdmin ? validationSchemaAdmin : validationSchema
    });

    const changeUser = (value) => { setUser(value); }

    const onSubmit = (data, _) => {
        if (isAdmin){
            if (user == null) {
                return showToastCustom(error, selectOption);
            }
            setLoading(true);
            return userService.resetPassword(user?.value, data.confirm_password)
                .then(_ => {
                    setLoading(false);
                    showToastCustom(success, updatePassword);
                    reset();
                    showModal();
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }else {
            setLoading(true);
            return userService.changeMyPassword(data.old_password, data.confirm_password)
                .then(_ => {
                    setLoading(false);
                    if (utilHelper.hasAssociateRecords()){
                        showToastCustom(error, badPassword, true);
                        utilHelper.restartAssociateRecords();
                    }else {
                        showToastCustom(success, updatePassword, true);
                        reset();
                        showModal();
                    }
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const showModal = () => {
        setModal(!modal);
    }

    useImperativeHandle(ref, () => ({
        showModal(userParam) {
            console.log(userParam)
            setUser(userParam);
            setModal(!modal);
        }
    }));

    const togglePasswordVisiblity = () => {
        setIsPasswordShown(!isPasswordShown);
    };

    return (
        <Modal
            isOpen={modal}
            toggle={showModal}
            className={props.className}>
            {loading && showLoader()}
            <ModalHeader toggle={showModal}>Cambiar contraseña</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {
                        isAdmin && <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Usuario</Label>
                                    <Select
                                        value={user}
                                        options={userOptions}
                                        placeholder="Selecciona una opción"
                                        isSearchable={true}
                                        isClearable={true}
                                        ref={register}
                                        onChange={changeUser}/>
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {
                        !isAdmin && <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Contraseña actual</Label>
                                    <InputGroup>
                                        <Input name="old_password"
                                               type={isPasswordShown ? "text" : "password"}
                                               innerRef={register}
                                               className={(errors.old_password ? ' is-invalid' : '')}/>
                                        <InputGroupAddon addonType="append">
                                            <Button color="secondary" onClick={togglePasswordVisiblity}>
                                                {isPasswordShown ? <i className="fas fa-eye-slash"/>:
                                                    <i className="fas fa-eye"/>}
                                            </Button>
                                        </InputGroupAddon>
                                    </InputGroup>
                                    <ErrorMessage errors={errors} name="old_password" component="div"
                                                  className="invalid-feedback"/>
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Nueva contraseña</Label>
                                <InputGroup>
                                    <Input name="password"
                                           type={isPasswordShown ? "text" : "password"}
                                           innerRef={register}
                                           className={(errors.password ? ' is-invalid' : '')}/>
                                    <InputGroupAddon addonType="append">
                                        <Button color="secondary" onClick={togglePasswordVisiblity}>
                                            {isPasswordShown ? <i className="fas fa-eye-slash"/>:
                                                <i className="fas fa-eye"/>}
                                        </Button>
                                    </InputGroupAddon>
                                </InputGroup>
                                <ErrorMessage errors={errors} name="password" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Confirmar Contraseña</Label>
                                <InputGroup>
                                <Input name="confirm_password"
                                       type={isPasswordShown ? "text" : "password"}
                                       innerRef={register}
                                       className={(errors.confirm_password ? ' is-invalid' : '')}/>
                                    <InputGroupAddon addonType="append">
                                        <Button color="secondary" onClick={togglePasswordVisiblity}>
                                            {isPasswordShown ? <i className="fas fa-eye-slash"/>:
                                                <i className="fas fa-eye"/>}
                                        </Button>
                                    </InputGroupAddon>
                                </InputGroup>
                                <ErrorMessage errors={errors} name="confirm_password" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmitPassword/>
                            <ButtonCancel onClick={() => {
                                showModal()
                            }}/>
                        </div>
                    </CardBody>
                </Form>
            </ModalBody>
        </Modal>
    )
})